import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcVolumeonFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.655 2.715c.802-.735 2.095-.166 2.095.922v16.727c0 1.087-1.293 1.656-2.095.921l-4.875-4.47a.25.25 0 0 0-.169-.065H4A1.75 1.75 0 0 1 2.25 15V9c0-.966.784-1.75 1.75-1.75h2.611a.25.25 0 0 0 .17-.065zM17.25 12c0-1.104-.55-2.08-1.394-2.668a.75.75 0 0 1 .858-1.23A4.75 4.75 0 0 1 18.75 12a4.75 4.75 0 0 1-2.036 3.899.75.75 0 0 1-.858-1.231A3.25 3.25 0 0 0 17.25 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.251 12c0-1.949-.892-3.69-2.293-4.837a.75.75 0 0 1 .951-1.16A7.74 7.74 0 0 1 21.751 12a7.74 7.74 0 0 1-2.842 5.997.75.75 0 0 1-.951-1.16A6.24 6.24 0 0 0 20.251 12"
  }));
}
var IcVolumeonFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVolumeonFill));

export { IcVolumeonFill as I };
